import { render } from "./about.vue?vue&type=template&id=450e2423&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=450e2423&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-450e2423"

export default script